import axios from 'axios';
import store from '@/store/index';

import {
  Toast
} from 'vant'
Toast.setDefaultOptions('loading', {
  forbidClick: true
})

axios.defaults.timeout = 30000;
axios.interceptors.request.use(
  config => {
    config.headers.openId = localStorage.getItem('openId')
    // config.headers.openId = '.gIdL2EoxgfuZQFJ'
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger') !== -1) {
      config.headers.appId = 'wx30c0b0a031d5b7ce'
    } else {
      config.headers.appId = 'wap30c0b0a031d5b7ce'
    }
    if (!navigator.onLine) {
      Toast('网络好像有点问题，请检查后重试！')
    } else {
      return config
    }
    console.log(config)
  },
  error => {
    console.log(error)
  }
)
// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(String(error))
    if (String(error).indexOf("timeout") > 0) {
      Toast('请求超时，请重试！')
    }
    return Promise.reject(error)
  }
)

// 封装axios.post
export function fetchPost(url, params) {
  console.log(url)
  return axios({
      url: url,
      data: params,
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        'Content-Type': 'application/json'
      },
      withCredentials: true
    })
    .then(res => {
      console.log('post', res)
      if (res.data.code === 0) {
        return res.data
      } else {
        // console.log(res)
        return res.data
      }
    })
    .catch(err => {
      console.log(err)
    })
}

// 封装axios.post
export function post(url, params) {
  console.log(url)
  return axios({
      url: url,
      data: params,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        // 'Content-Type': 'application/json'
      },
      transformRequest: [function(data) {
        var ret = ''
        for (var it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      withCredentials: true
    })
    .then(res => {
      console.log('post', res)
      if (res.data.code === 0) {
        return res.data
      } else {
        // console.log(res)
        return res.data
      }
    })
    .catch(err => {
      console.log(err)
    })
}

export function fetchGet(url, params) {
  console.log(url)
  return axios
    .get(url, {
      params: params
    })
    .then(res => {
      if (res.data.code === 0) {
        // console.log(res.data)
        return res.data
      } else {
        return res.data
      }
    })
    .catch(err => {
      console.log(err)
    })
}
